var _linearGradient, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_ren",
    gradientUnits: "userSpaceOnUse",
    y1: 16,
    x2: 32,
    y2: 16
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#001e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#001f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002042"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#SVGID_1_ren)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9 9.3l1.7-.9.2.4 6.2-3.6-.4-.3-.5-.3-.2-.1-10.2 5.9v.2L8.7 9zM9 13.1l4.9-2.9.2.4L20.4 7l-.5-.3-.5-.2-.2-.1-13.4 7.7v.2l2.9-1.6zM9 14.9l6.5-3.7.2.3L22 7.9l-.5-.2-.5-.3-.2-.1-15 8.6v.3l2.9-1.7zM9 16.7l8.1-4.6.2.3 6.3-3.5-.5-.3-.5-.3-.2-.1-16.6 9.6v.2l2.9-1.6zM9 18.6l9.7-5.6.2.4 6.3-3.6-.5-.3-.4-.2-.3-.2L5.8 19.6v.3l2.9-1.7zM25.8 10.2l-.2-.2L5.8 21.5v.2l2.9-1.6.3.4 9.7-5.7.2.4 7.3-4.1v-.7zM7.1 22.9l1.6-1 .2.4 9.8-5.6.2.4 7.3-4.2v-1.3L6.8 22.7zM18.7 18.6l.2.4 7.3-4.3v-1.3L8.4 23.7l.3.1 1.6-1 .3.4M10.3 24.7l1.7-.9.2.4 6.5-3.8.2.4 7.3-4.2v-1.3L10 24.6zM11.9 25.6l1.7-.9.2.4 4.9-2.8.2.4 7.3-4.2V17.1l-14.6 8.4zM13.2 26.4l.3.2 1.7-1 .2.4 3.3-1.9.2.4 7.3-4.2V19zM15.1 27.5l1.6-1 .3.4 1.7-.9.2.4 7.3-4.2V20.8l-11.3 6.6zM18.8 6.1l-.5-.3-.5-.2-.2-.2-11.8 6.8v.3l2.9-1.7.3.4 3.3-1.9.2.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRen);
export default __webpack_public_path__ + "static/media/ren.06fa627cb0e0d8bfea81d527a036189d.svg";
export { ForwardRef as ReactComponent };